










































    import { Component, Prop } from "vue-property-decorator";
    import { UserProfile } from "@api/models/UserProfile";
    import { Tag } from '@api/models/Tag';

    import UsersList from "@share/common/users-list/UsersList.vue";
    import TagList from "@share/common/tag-list/TagList.vue";
    import KebabMenu from "@share/common/kebab-menu/KebabMenu.vue";
    import CardEditButton from "@share/common/buttons/CardEditButton-01.vue";
	import { getImageUrl } from "@common/ImageUrlHelper";
    import { DropDownItem } from "@share/common/drop-down/types";
    import { MenuEvent } from "@api/enums/MenuEvents";
    import { Modal } from "@common/Modal";
    import PartnerActions from "./common/PartnerActions.vue";

    import CopyIcon from "../../../assets/svg/copy-icon.svg";

    @Component({
        components: { UsersList, TagList, KebabMenu, CardEditButton, CopyIcon }
    })
    export default class PartnerCard extends PartnerActions {
        @Prop({required: false}) partnerId: string;
        @Prop({required: true}) message: string;
        @Prop({required: false}) imageId: string;
        @Prop({required: false}) parent: string | any;
        @Prop({required: false, default: false}) showTitle: boolean;
        @Prop({required: false, default: false}) isOnline: boolean;
        @Prop({required: false, default() {return []}}) profiles: UserProfile[];
        @Prop({required: false, default() {return []}}) tags: Tag[];
        @Prop({required: false, default: false}) hasVideo: boolean;
        @Prop({ default: false }) isMain: boolean;
        @Prop({ default: false }) removed: boolean;

        linkCopied = false;
        MenuEvent = MenuEvent;

        async chooseHandler(eventName: MenuEvent) {
            if (eventName === MenuEvent.delete) {
                const confirmed = await this.doConfirm();

                if(confirmed && confirmed !== "close") {
                    this.$emit(MenuEvent.delete, this.partnerId);
                }
            }

            if(eventName === MenuEvent.copyLink) {
                this.copyLink(this.partnerId);
            }
        }

        async doConfirm() {
            const modal = new Modal({
                title: this.$t('exhibition.deletePartnerConfirmTitle').toString(),
                buttons: [
                    {
                        text: this.$t('common.yes').toString(),
                        class: 'is-green is-middle',
                        returnValue: true
                    },
                    {
                        text: this.$t('common.no').toString(),
                        class: 'is-red is-middle',
                        returnValue: false
                    },
                ]
            });

            return await modal.showConfirm()
        }

        get menuItems(): DropDownItem[] {
            return [
                {
                    title: this.linkCopied ? this.$t('common.copied').toString() : this.$t('common.copyLink').toString(),
                    id: MenuEvent.copyLink
                },
                {
                    title: this.$t('common.delete').toString(),
                    id: MenuEvent.delete
                }
            ];
        }

        get image(): string {
            return getImageUrl(this.$store.state.session.backend, this.imageId, 512);
        }

        get profilesForRender() {
            return this.profiles.filter((profile, index) => {
                return this.isOnline
                    ? index < 3
                    : index < 3
            })
        }

        get profilesLength(): number {
            return Object.keys(this.profiles).length;
        }
    }
